import { types, actions } from './requests'
export const DELETERECIPE_TYPES = {
    ...types('DELETERECIPE'),
}
export const DELETERECIPE_ACTIONS = {
    ...actions('DELETERECIPE'),
}